exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".intl-layout[data-v-214a6441] {\n  min-height: 100vh;\n  background: #EDF4F7;\n  display: flex;\n  flex-direction: column;\n}\n.intl-layout__main[data-v-214a6441] {\n  flex: 1;\n  width: 6.25rem;\n  max-width: calc(100% - 0.208333rem);\n  margin: 0 auto;\n  padding-bottom: 0.25rem;\n}\n\n/* 移动端覆盖样式见 mobile/intl-mobile.css（不被 postcss-px2rem 转换） */", ""]);

// exports
